import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES } from '../lib/constants';
import { useListings } from '../hooks/useListings';
import Empty from '../components/Empty';
import Icon from '../components/Icon';
import ListingCard from '../components/ListingCard';

export default function HomePage({ user, browseLocation, onRequestAuth }) {
  const [category, setCategory] = useState('All');
  const { listings, loading, error } = useListings({
    category,
    location: browseLocation.location,
    radiusMiles: browseLocation.radiusMiles,
    sort: 'newest',
    enabled: Boolean(user),
  });

  if (!user) {
    return <section className="home guest-preview" aria-hidden="true" />;
  }

  return (
    <section className="home">
      <div className="section-heading">
        <div>
          <h1>Fresh finds</h1>
          <p>
            {browseLocation.label !== 'Set location'
              ? `Near ${browseLocation.label}`
              : 'Recently listed near you'}
          </p>
        </div>
        <Link to="/search">
          View all <Icon name="chevron" size={16} />
        </Link>
      </div>

      <div className="category-row">
        {CATEGORIES.map((x) => (
          <button
            key={x}
            type="button"
            onClick={() => setCategory(x)}
            className={category === x ? 'selected' : ''}
          >
            {x}
          </button>
        ))}
      </div>

      {error && <p className="form-error">{error}</p>}

      {loading ? (
        <div className="listing-grid skeleton-grid">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="listing-skeleton" />
          ))}
        </div>
      ) : listings.length ? (
        <div className="listing-grid">
          {listings.map((item) => (
            <ListingCard key={item.id} item={item} />
          ))}
        </div>
      ) : (
        <Empty
          icon="search"
          title="No listings nearby"
          body="Try a larger radius from the location chip in the header, or pick another category."
        />
      )}
    </section>
  );
}
